export default "__VITE_ASSET__CxMKWZ88__"